import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  panel: {
    border: `1px solid ${theme.colorPalette.beige_60}`,
    borderRadius: theme.sizes.roundCorners,
    backgroundColor: theme.colorPalette.white,
    padding: theme.spacing(4, 5)
  },
  heading: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    gap: theme.spacing(3)
  },
  starts: {
    fontSize: 13,
    color: theme.colorPalette.beige_90
  },
  title: {
    margin: 0,
    fontSize: 16,
    fontWeight: 600,
    color: theme.colorPalette.green_100
  },
  rows: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) auto',
    gap: theme.spacing(2, 4),
    margin: theme.spacing(3, 0, 0),
    fontSize: 14,
    color: theme.colorPalette.green_100,
    '& dd': {
      margin: 0,
      textAlign: 'right',
      fontVariantNumeric: 'tabular-nums'
    }
  },
  was: {
    marginRight: theme.spacing(2),
    color: theme.colorPalette.beige_90
  },
  description: {
    margin: theme.spacing(2, 0, 0),
    fontSize: 14,
    whiteSpace: 'pre-line',
    color: theme.colorPalette.green_100
  }
});

export default makeStyles(styles);
